"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextWrapper = exports.StyledText = exports.StyledSubHeading = exports.StyledParagraph = exports.StyledHeadingSpan = exports.StyledHeading = exports.StyledContentBanner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
var _variantConfig = _interopRequireDefault(require("./variant-config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledContentBanner = exports.StyledContentBanner = _styledComponents["default"].div.attrs({
  className: 'fuse-content-banner-2'
}).withConfig({
  displayName: "styled-content-banner-2__StyledContentBanner",
  componentId: "sc-ow4o7p-0"
})(["border:none;display:grid;gap:var(--spacing-global-space7);padding:var(--spacing-global-space7);text-decoration:none;text-align:center;", " ", ";box-sizing:border-box;box-shadow:inset 0 0 0 var(--border-width-xl) ", ";@media screen and (min-width:", "){padding:var(--spacing-global-space8) var(--spacing-global-space7);box-shadow:inset 0 0 0 12px ", ";}@media screen and (min-width:", "){padding:var(--spacing-global-space8) var(--spacing-global-space9);box-shadow:inset 0 0 0 16px ", ";}.fuse-span-button{margin:auto;}&:focus{outline:var(--border-radius-s) solid var(--color-functional-focus);outline-offset:-2px;}&:hover{.fuse-span-button{box-shadow:var(--elevation-shadow-s);border:var(\u2014border-width-xs) solid var(--color-brand-mid);}}&:active{.fuse-span-button{box-shadow:inset 0 0 0 var(--border-radius-s) var(--color-global-white);color:var(--color-brand-mid);background-color:var(--color-global-white);&:before{background:var(--color-brand-mid);}}}"], function (props) {
  return props.as === 'button' ? "\n\t\tcursor: pointer;\n\t" : "";
}, function (props) {
  return props.variant && "background: ".concat(_variantConfig["default"][props.variant].background, ";");
}, function (props) {
  return props.variant && _variantConfig["default"][props.variant].defaultBorder ? 'var(--color-brand-mid)' : 'transparent';
}, _grid.gridConfig.m.minWidth, function (props) {
  return props.variant && _variantConfig["default"][props.variant].defaultBorder ? 'var(--color-brand-mid)' : 'transparent';
}, _grid.gridConfig.l.minWidth, function (props) {
  return props.variant && _variantConfig["default"][props.variant].defaultBorder ? 'var(--color-brand-mid)' : 'transparent';
});
var StyledText = exports.StyledText = _styledComponents["default"].div.attrs({
  className: 'fuse-content-banner-2__text',
  'data-testid': 'fuse-content-banner-2-text-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledText",
  componentId: "sc-ow4o7p-1"
})(["display:grid;gap:var(--spacing-global-space2);div{display:grid;gap:var(--spacing-global-space5);}"]);
var StyledHeading = exports.StyledHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-banner-2__heading',
  'data-testid': 'fuse-content-banner-2-heading-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledHeading",
  componentId: "sc-ow4o7p-2"
})(["&&{color:var(--color-global-white);}"]);
var StyledHeadingSpan = exports.StyledHeadingSpan = _styledComponents["default"].span.attrs({
  className: 'fuse-content-banner-2__heading-span',
  'data-testid': 'fuse-content-banner-2-heading-span-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledHeadingSpan",
  componentId: "sc-ow4o7p-3"
})(["&&{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;span{font-size:var(--font-size-9);line-height:var(--font-line-height-9);text-transform:uppercase;color:", ";@media screen and (min-width:", "){font-size:var(--font-size-10);line-height:var(--font-line-height-10);}@media screen and (min-width:", "){font-size:var(--font-size-12);line-height:var(--font-line-height-12);}}}"], function (props) {
  return props.variant === 'brand' ? 'var(--color-brand-enhancedText)' : 'var(--color-brand-onBlack)';
}, _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);
var StyledTextWrapper = exports.StyledTextWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-banner-2__text-wrapper',
  'data-testid': 'fuse-content-banner-2-text-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledTextWrapper",
  componentId: "sc-ow4o7p-4"
})([""]);
var StyledSubHeading = exports.StyledSubHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-banner-2__subheading',
  'data-testid': 'fuse-content-banner-2-subheading-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledSubHeading",
  componentId: "sc-ow4o7p-5"
})(["&&{color:var(--color-global-white);}"]);
var StyledParagraph = exports.StyledParagraph = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-banner-2__paragraph',
  'data-testid': 'fuse-content-banner-2-paragraph-test-id'
}).withConfig({
  displayName: "styled-content-banner-2__StyledParagraph",
  componentId: "sc-ow4o7p-6"
})(["&&{color:var(--color-global-white);margin-bottom:0;}"]);